<script lang="ts">
    import type { OrganizationInviteData } from "@anyways-open/identity-api-client/dist/data/OrganizationInviteData";
    import { TrashIcon } from "@anyways-open/common-svgs";

    export let data: OrganizationInviteData;

    const onRemove = () => {

    };
</script>

<div class="list-group-item">
    <div class="row align-items-center">
        <div class="col-6">
            <p class="mb-0">{data.email}</p>
        </div>
        <div class="col-auto ms-auto">
            {#if !data.accepted}
                {#if data.declined}
                    Declined
                {:else}
                    Pending
                {/if}
            {:else}
                Accepted
            {/if}
            <button
                class="btn icon icon-xs text-dark d-inline p-0"
                title="Delete"
                on:click={onRemove}>
                <TrashIcon />
            </button>
        </div>
    </div>
</div>
